export default {
  app: {
    orgCode: "លេខសំរាប់​ក្រុម/ម៉ាក",
    orgCodePlaceholder: "សូមបញ្ចូលលេខសំរាប់ក្រុម/ម៉ា",
    username: "គណនី",
    usernamePlaceholder: "សូមបញ្ចូលគណនីមួយ។",
    password: "ពាក្យសម្ងាត់",
    passwordPlaceholder: "សូមបញ្ចូលពាក្យសម្ងាត់",
    captcha: "កូដ​ផ្ទៀង​ផ្ទាត់",
    captchaPlaceholder: "សូមបញ្ចូលលេខកូដផ្ទៀងផ្ទាត់",
    captchaExpired: "សូមធ្វើឱ្យទ្រង់ទ្រាយកូដបញ្ជាក់រួចស្រេច",
    login: "ចូល",
    remember: "ចងចាំព័ត៌មានចូល",
    switchPC: "ភាសាចំណុចប្រទាក់",
    mobileVersion: "BI ទូរស័ព្ទ",
    desktopVersion: "Backend អ្នកលក់",
    setupPassword: "កំណត់ពាក្យសម្ងាត់",
    newPassword: "ពាក្យសម្ងាត់​ថ្មី",
    newPasswordPlaceholder: "សូមបញ្ចូលពាក្យសម្ងាត់ថ្មី។",
    retypePassword: "បញ្ចូលពាក្យសម្ងាត់ថ្មីម្តងទៀត",
    retypePasswordPlaceholder: "សូមបញ្ចូលពាក្យសម្ងាត់ថ្មីម្តងទៀត",
    setupPasswordRule: "ពាក្យសម្ងាត់ត្រូវមានចន្លោះពី៦-៣២តួអក្សរនិងមានយ៉ាងហោចណាស់ពីរពីអ្វីខ្លះ: លេខ អក្សរ សញ្ញា។",
    setupPasswordRuleRefer: "ពាក្យសម្ងាត់ត្រូវមានពី 6 ទៅ 32 តួអក្សរ ហើយមានបន្សំលេខ អក្សរ និងនិមិត្តសញ្ញាច្រើនជាងពីរ។ សូមបញ្ចូលម្តងទៀត។",
    setupPasswordOk: "ប្រាកដ",
    setupPasswordDiffer: "ពាក្យសម្ងាត់ដែលបានបញ្ចូលពីរដងគឺមិនជាប់លាប់ទេ សូមបញ្ចូលម្តងទៀត។",
    err_def: "បរាជ័យក្នុងការចូលប្រើ, សូមធ្វើការផ្ទុកទំព័រឡើងវិញ ហើយព្យាយាមម្តងទៀត។",
    err_2000: "កំហុសក្នុងការបញ្ចូលលេខកូដផ្ទៀងផ្ទាត់។",
    err_2010: "ព័ត៌មានចូលប្រើដែលបានបញ្ចូលមិនត្រឹមត្រូវ។",
    err_4001: "គណនីនេះមិនត្រូវបានអនុញ្ញាតសម្រាប់មុខងារណាមួយឡើយ។",
    err_4011: "ហាងត្រូវបានបិទ មិនអាចចូលប្រើបាន។",
    err_4012: "អាជ្ញាបណ្ណត្រូវបានបិទ មិនអាចចូលប្រើបាន។",
    err_4013: "ម៉ាកត្រូវបានបិទ មិនអាចចូលប្រើបាន។",
    err_4014: "ក្រុមត្រូវបានបិទ, មិនអាចចូលប្រើបាន។",
    err_4015: "តំបន់ត្រូវបានបិទមិនអាចចូលបានឡើយ។",
    err_4401: "គណនីនេះមិនត្រូវបានអនុញ្ញាតសម្រាប់ហាងនេះទេ។",
    err_4402: "គណនីនេះគ្មានសិទ្ធិអ្នកគ្រប់គ្រង ហើយមិនអាចទទួលបានលេខកូដផ្ទៀងផ្ទាត់បានទេ។",
    err_5001: "ការកំណត់ពាក្យសម្ងាត់បរាជ័យទៀត។ សូមព្យាយាមម្តងទៀត។",
  },
  verifyRefund: {
    title: "ការស្នើសុំប្រគល់វិញ",
    hint: "សូមបញ្ជាក់ព័ត៌មានប្រគល់វិញមុនពេលផ្តល់លេខកូដ។",
    verifyCode: "លេខកូដផ្ទៀងផ្ទាត់",
    copy: "ការបិទភ្ជាប់",
    copySucceed: "សម្រួលបានជោគជ័យ។",
    copyFailed: "ចម្លងបរាជ័យ។",
    expireTime: "ពេលវេលាផុតកំណត់",
    shop: "ហាង",
    soTime: "ពេលវេលាបញ្ជាទិញ",
    soNo: "លេខការបញ្ជាទិញ POS",
    amount: "ចំនួនទឹកប្រាក់ប្រគល់វិញ",
  },
}